import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { scenarios } from '../data/scenarios';
export function ScenarioList() {
  const {
    hash
  } = useLocation();
  const [openId, setOpenId] = useState<string | null>(scenarios[0].id);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    const target = hash.replace('#', '');
    if (!target) return;
    const match = scenarios.find(scenario => scenario.id === target);
    if (!match) return;
    setOpenId(match.id);
    const element = document.getElementById(match.id);
    if (element) {
      element.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'center'
      });
    }
  }, [hash, reduceMotion]);
  return <ul className="border-t border-ink-200" data-id="element-45" data-mp="2y3gxct42ryrg">
      {scenarios.map(scenario => {
      const isOpen = openId === scenario.id;
      const panelId = `scenario-panel-${scenario.id}`;
      return <li key={scenario.id} id={scenario.id} className="border-b border-ink-200" data-id="element-46" data-mp="cjec89hw1cvf">
            <h3 data-id="element-47" data-mp="clh30vqv7a17">
              <button type="button" onClick={() => setOpenId(isOpen ? null : scenario.id)} aria-expanded={isOpen} aria-controls={panelId} className="group flex w-full items-start gap-5 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-paper sm:gap-8" data-id="element-48" data-mp="hih7j282g4q7">
                <span className="mt-1 w-7 shrink-0 font-display text-sm text-accent" data-id="element-49" data-mp="10a08l3ij58pl">
                  {scenario.number}
                </span>
                <span className="min-w-0 flex-1" data-id="element-50" data-mp="15a61so4g739s">
                  <span className="block font-display text-[22px] leading-snug text-ink-950 sm:text-[26px]" data-id="element-51" data-mp="1a7xxzuc4lbjs">
                    {scenario.title}
                  </span>
                  <span className="mt-1.5 block max-w-xl text-[15px] leading-relaxed text-ink-500" data-id="element-52" data-mp="phuaw8daz6u5">
                    {scenario.summary}
                  </span>
                </span>
                <span aria-hidden="true" className="mt-1 flex h-7 w-7 shrink-0 items-center justify-center border border-ink-200 text-ink-500 transition-colors duration-150 ease-out group-hover:border-accent group-hover:text-accent" data-id="element-53" data-mp="kh6c30iu1lpd">
                  {isOpen ? <MinusIcon className="h-3.5 w-3.5" data-id="element-54" data-mp="18aepcks999ef" /> : <PlusIcon className="h-3.5 w-3.5" data-id="element-55" data-mp="13aa4kikbdsie" />}
                </span>
              </button>
            </h3>

            <AnimatePresence initial={false} data-id="element-56" data-mp="1i5gehgmj6bh0">
              {isOpen && <motion.div id={panelId} key="panel" initial={reduceMotion ? undefined : {
            height: 0,
            opacity: 0
          }} animate={reduceMotion ? undefined : {
            height: 'auto',
            opacity: 1
          }} exit={reduceMotion ? undefined : {
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-57" data-mp="1d7eu8sddc63y">
                  <div className="grid gap-8 pb-10 sm:grid-cols-2 sm:gap-12 sm:pl-[3rem]" data-id="element-58" data-mp="1kr7an79zl8s9">
                    <div data-id="element-59" data-mp="1pqahmx9j1p2v">
                      <p className="text-[11px] uppercase tracking-label text-ink-500" data-id="element-60" data-mp="1ppr1nm3ftarh">Problem</p>
                      <p className="mt-3 text-[15px] leading-relaxed text-ink-700" data-id="element-61" data-mp="1bpzp7pskk2fl">
                        {scenario.problem}
                      </p>
                    </div>
                    <div className="border-l-0 border-t border-ink-100 pt-8 sm:border-l sm:border-t-0 sm:pl-10 sm:pt-0" data-id="element-62" data-mp="11sbjy5xc7cj6">
                      <p className="text-[11px] uppercase tracking-label text-accent" data-id="element-63" data-mp="16qwlq9s8m49q">Our approach</p>
                      <p className="mt-3 text-[15px] leading-relaxed text-ink-900" data-id="element-64" data-mp="2w62zfm2ckqmj">
                        {scenario.solution}
                      </p>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}